import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IAddServerAgentAuthParam, IServerAgentAuthItem, IServerAgentAuthParam } from '../../types/crowd-source/agent-auth';
import { IProductAuthListParam, IServerProductItem } from '../../types/crowd-source/product';

const hostUrl = getHostbaseUrl();

/**
 * 众包灵工 - 特代授权 - 分页查询
 */
export async function queryServerAgentAuthPage(param: IServerAgentAuthParam) {
  let data = [] as IServerAgentAuthItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IServerAgentAuthParam;

  try {
    const { code, context, message } = await Http.post<{ data: IServerAgentAuthItem[]; total: number }>(`${hostUrl}/side/server/product/auth/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IServerAgentAuthItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 众包灵工 - 特代授权 - 授权、停止授权
 */
export async function changeServerAgentAuthStatus(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/product/auth/added`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 特代授权 - 集合查询(未授权产品)
 */
export async function queryProductNotAuth(param: IProductAuthListParam, isCompany = false) {
  let data = [] as IServerProductItem[];

  try {
    const { code, context, message } = await Http.post<IServerProductItem[]>(`${hostUrl}/side/server/product${isCompany ? '/auth' : ''}/listNotAuth`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IServerProductItem[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 众包灵工 - 特代授权 - 新增授权
 */
export async function saveProductNotAuth(params: IAddServerAgentAuthParam, editType: boolean) {

  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/product/auth/${editType ? 'config' : 'add'}`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 特代授权 - 删除
 */
export async function deleteAgentAuth(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/product/auth/delete`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
